var map = {
	"./cross-section.png": 6443,
	"./gallery-1.jpg": 1653,
	"./gallery-10.jpg": 2841,
	"./gallery-2.jpg": 4314,
	"./gallery-3.jpg": 5700,
	"./gallery-4.jpg": 9532,
	"./gallery-5.jpg": 6905,
	"./gallery-6.jpg": 766,
	"./gallery-7.jpg": 7227,
	"./gallery-8.jpg": 2320,
	"./gallery-9.jpg": 9421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7906;